// src/components/ui/RefreshButton.jsx

import React from 'react';
import { Icons } from '../dashboard/Icons';
import Button from './Button';
import { SPIN_KEYFRAMES } from './theme';

export default function RefreshButton({
  onClick,
  refreshing = false,
  size = 'md',
  style,
  ...rest
}) {
  return (
    <>
      <Button
        variant="primary"
        size={size}
        onClick={onClick}
        refreshing={refreshing}
        style={style}
        {...rest}
      >
        <span
          style={{
            display: 'inline-flex',
            animation: refreshing ? 'ui-spin 0.9s linear infinite' : 'none',
          }}
        >
          <Icons.refresh />
        </span>
        {refreshing ? 'Refreshing...' : 'Refresh'}
      </Button>
      <style>{SPIN_KEYFRAMES}</style>
    </>
  );
}
